import VueRouter from "vue-router"
import Login from "../components/login/Template"
import ContasConsumo from "@/modulos/contas_consumo/routes/contas_consumo"
// import ObrasGestao from "@/modulos/obras_gestao/routes/obras_gestao"

import InicioAdm from "@/components/adm/Template"
import Usuario from "@/components/adm/usuario/UsuarioEditar"

let index = ContasConsumo;

index.push(
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/usuario',
        component: InicioAdm,
        children: [
            {
                path: 'editar',
                alias: '',
                component: Usuario,
                name: 'Usuario'
            }
        ]
    },
);

export const router = new VueRouter({
    routes: index,
    mode: 'history',
    linkExactActiveClass: 'active',
});

router.beforeEach((to, from, next) => {
    const publicPag = ['/login', '/cadastro'];
    const authReq = !publicPag.includes(to.path);

    if (authReq && !store.state.global.logado) {
        return next('/login');
    }

    next();
});

export default router
